<template>
  <button
    :class="classes"
    :disabled="disabled"
    type="button"
  >
    <!-- @slot Der Default Slot stellt den Text/Inhalt des Buttons dar -->
    <slot />
  </button>
</template>

<script>
/**
 * Komponente zur Anzeige von Buttons.
 * Verwendung: `<base-button color="info" :sm>Speichern</base-button>`
 * Output: `<button type="button" class="btn btn-outline-secondary btn-sm">Speichern</button>`
 * https://getbootstrap.com/docs/5.0/components/buttons/
 * @displayName BaseButton
 */
export default {
  name: 'BaseButton',
  props: {
    /**
     * Button Farben
     */
    color: {
      type: String,
      default: 'primary',
      validator(value) {
        return [
          'default',
          'primary',
          'secondary',
          'success',
          'danger',
          'warning',
          'info',
          'link'
        ].includes(value)
      }
    },
    /**
     * Soll ein Ghost Button dargestellt werden?
     */
    outline: {
      type: Boolean,
      default: false
    },
    /**
     * Soll ein kleiner Button dargestellt werden?
     */
    sm: {
      type: Boolean,
      default: false
    },
    /**
     * Soll ein großer Button dargestellt weden?
     */
    lg: {
      type: Boolean,
      default: false
    },
    /**
     * Soll der Button deaktiviert sein?
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Soll der Button zusätzliche Klassen erhalten?
     */
    additionalClasses: {
      type: String,
      default: ''
    }
  },
  computed: {
    classes() {
      let string = 'btn ';

      // add color
      if (this.outline) {
        string = string + 'btn-outline-' + this.color;
      }
      else {
        string = string + 'btn-' + this.color;
      }

      // sizing
      if (this.sm) {
        string = string + ' btn-sm';
      }

      if (this.lg) {
        string = string + ' btn-lg';
      }

      string = string + ' ' + this.additionalClasses;

      return string
    }
  }
};
</script>
